import lazysizes from 'lazysizes';
import 'lazysizes/plugins/noscript/ls.noscript';
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import LinkFocusHelper from './components/00_utilities/helpers/LinkFocusHelper';
import DataLayerHelper from './components/00_utilities/helpers/DataLayerHelper';
import AccessibilityHelper from './components/00_utilities/helpers/AccessibilityHelper';
import YoutubeHelper from './components/00_utilities/helpers/YoutubeHelper';
import CookieHelper from './components/00_utilities/helpers/CookieHelper';
import AnchorLinkHelper from './components/00_utilities/helpers/AnchorLinkHelper';

lazysizes.cfg.loadHidden = 0; // do not preload visibility:hidden images

const componentHelper = new ComponentHelper();

/* eslint-disable */
const __svg__ = { path: './svg/*.svg', name: 'Icons/icons.svg', filename: svgFileName };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:8085/typo3conf/ext/sfsitepackage/Resources/Public/';

    /**
     * Check for hot module replacement and use it if possible
     */
    if (module.hot) {
        module.hot.accept();
    }
}
/* eslint-enable */

// initialize for tracking
window.dataLayer = window.dataLayer || [];

window.addEventListener('load', () => {
    window.youtubePlayers = [];

    componentHelper.initializePage();
    LinkFocusHelper.handleHashLink();
    AnchorLinkHelper.initializeAnchorLinks(lazysizes);
    (new DataLayerHelper()).init();

    // handleEventForm();
    AccessibilityHelper.reduceMotion(({ matches }) => {
        if (matches) {
            document.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
        }
    });

    // initialize marketing cookie behaviour for Youtube
    const customEventsOnMarketingAccept = ['consent-type-youtube'];
    CookieHelper.addMarketingCookieListener(customEventsOnMarketingAccept);
    YoutubeHelper.addYoutubeConsentListener();
});
